<div fxLayout="column">
    <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center" class="modal-header">
        <span fxFlex="grow" class="modal-title">Πληροφορίες χρήστη</span>
        <mat-icon (click)="close()" class="modal-close">close</mat-icon>
    </div>

    <div fxLayout="row" fxFlex="grow">
        <app-user-info mode="preview" (closeWindow)="checkWindowState($event)" *ngIf="!isLoading" [user]="parentInfo" [providers]="notificationProviders"></app-user-info>
    </div>
    <app-loading *ngIf="isLoading"></app-loading>
</div>
